import { Dispatch } from 'react';
import { TServiceClientActionTypes } from '../types';
import { TFunction } from 'i18next';
import { VariantType } from 'notistack';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { UPDATE_SERVICE_CLIENT } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';

export type TDeleteServiceClientVehicleServiceHistoryDeps = {
    t: TFunction;
    customAlert: (
        message: string,
        variant?: VariantType,
        options?: Record<string, unknown>,
        actionUrl?: string,
        playSound?: boolean
    ) => void;
};

export const deleteServiceClientVehicleServiceHistory = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    serviceClientId: string,
    vehicleId: string,
    serviceHistoryId: string,
    deps: TDeleteServiceClientVehicleServiceHistoryDeps
): Promise<boolean | undefined> => {
    const { t, customAlert } = deps;

    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.delete(
            `/service-clients/${serviceClientId}/vehicle/${vehicleId}/service-history/${serviceHistoryId}/delete`,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: UPDATE_SERVICE_CLIENT,
            payload: res.data.data,
        });

        customAlert(t('SnackBar.ServiceClientUpdated'), 'success');

        return true;
    } catch (error) {
        if (error instanceof Error)
            dispatch(
                handleError(error, (message) =>
                    customAlert(message, 'error')
                )
            );
    }
};
